<template>
  <UIModalContent>
    <div class="ModalPublishToWeb__body">
      <p class="ModalPublishToWeb__intro">
        Your webpage is now live and available to all Foundever users with the
        link.
      </p>
      <UIShareableLinkPreview
        v-if="publishedShareHref"
        :url="publishedShareHref"
        aria-label="Published share link"
      />
      <p class="ModalPublishToWeb__footnote">
        You can manage or unpublish this asset anytime from your
        <RouterLink
          class="ModalPublishToWeb__footnote-link"
          :to="{ name: 'Library' }"
        >
          Library
        </RouterLink>
      </p>
    </div>
  </UIModalContent>

  <UIModalActions>
    <UIButton type="button" theme="secondary" @click="emit('close')">
      Close
    </UIButton>
    <UIButton type="button" @click="emit('open-live-preview')">
      Open live preview
    </UIButton>
  </UIModalActions>
</template>

<script lang="ts" setup>
import { UIButton, UIModalActions, UIModalContent } from '@foundever/ui-lib'

import UIShareableLinkPreview from '@/views/components/ui/misc/UIShareableLinkPreview.vue'

defineProps<{
  publishedShareHref: string
}>()

const emit = defineEmits<{
  close: []
  'open-live-preview': []
}>()
</script>

<style scoped lang="scss">
.ModalPublishToWeb__body {
  .ModalPublishToWeb__footnote {
    margin: 0;
    @include font-body-small-regular;
    color: var(--text-secondary);
  }

  .ModalPublishToWeb__footnote-link {
    color: var(--text-secondary, #57576b);
  }

  .ModalPublishToWeb__intro {
    color: var(--text-primary, #12123f);
    @include font-body-small-regular;
  }
}
</style>
